import { ExportDataService } from '../../../../shared/services/export-data.service';
import { MaintenanceService } from '../../../services/maintenanceService';
import { SharedService } from '../../../../shared/services/shared.service';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleChanges, OnInit, OnChanges, NO_ERRORS_SCHEMA } from '@angular/core';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { CapitalMaintenanceV4Component } from '../capital-maintenance-table/capital-maintenance-table.component';
import { ToastrService } from 'ngx-toastr';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { DropdownWithSearchComponent } from '../../../../shared/elements/dropdown-with-search/dropdown-with-search.component';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddUcmgComponent } from '../add-ucmg/add-ucmg.component';
import { BillionsToBMillionsToMThousandsToK } from '../../../../shared/pipe/billionsToB-millionsToM-thousandsToK.pipe';
@Component({
    selector: 'app-capital-maintenance',
    templateUrl: './capital-maintenance.component.html',
    styleUrl: './capital-maintenance.component.scss',
    imports: [MatSlideToggle, FormsModule, MatFormField, MatInput, DropdownWithSearchComponent, LoaderComponent, CapitalMaintenanceV4Component, AppModalComponent, AddUcmgComponent, BillionsToBMillionsToMThousandsToK],
    schemas: [NO_ERRORS_SCHEMA],
})
export class CapitalMaintenanceComponent implements OnChanges, OnInit {
  @ViewChild(CapitalMaintenanceV4Component) capTableComponent: CapitalMaintenanceV4Component;
  @ViewChild('addUcmgPopup', { static: false }) addUcmgPopup;
  @Input() clearFilters: boolean = false;
  checked = false;
  exportToExcel: number = 1;
  allRowsExpanded = false;
  dataSourceDetails: MatTableDataSource<any>;
  olddatasource: any;
  kpidatasource: any;
  UCMGDetailsList: any;
  currentTable: string = 'investment-summary';
  TABLE_COLUMNS: any = [
    {
      key: 'Funding_Source',
      labelKey: "Funding_Source",
      label: 'Funding Source',
      width: '11.5% !important',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': true }],
      padding: '5px 2px 5px 4px !important'
    },
    {
      key: 'Funding_SegmentID',
      labelKey: "Funding_SegmentID",
      label: 'Funding Segment ID',
      width: '13.8% !important',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': true }],
      padding: '5px 2px 5px 3px !important'
    },
    {
      key: 'Funding_Segment',
      width: '13% !important',
      label: 'Funding Segment',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 5px 5px 0 !important',
      isLink: true
    },
    {
      key: 'Funding_Owner',
      labelKey: "Funding_Owner",
      width: '13% !important',
      addNew: true,
      label: 'Funding Owner',
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 25px 5px 0px !important'
    },
    {
      key: 'ucmg_count',
      labelKey: "UCMG_ID",
      width: '12% !important',
      addNew: true,
      label: 'UCMG Count',
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'flagged_ucmg_count',
      labelKey: "Flagged_UCMG_ID",
      width: '16% !important',
      addNew: true,
      label: 'Flagged UCMG Count',
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'total_acap',
      labelKey: "Total_Forecast",
      width: '12% !important',
      addNew: true,
      label: 'Total Forecast',
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'total_OT',
      labelKey: "Total_OT",
      width: '12% !important',
      addNew: true,
      label: 'Total OT',
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important',
      isLastColumn :true
    },
  ];

  expanded_columns : any = [
    
    {
      key : 'UCMG_ID',      
      labelKey: 'UCMG_ID',
      label: 'UCMG ID',
      width: '10% !important',
      edit: true,
      addNew: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }]
    },
    {
      key: 'UCMG_Name',
      labelKey: "UCMG_Name",
      label: 'UCMG Name',
      width: '14% !important',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }]
    },
    {
      key: 'ACAP',
      label: 'ACAP',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
    },
    {
      key: 'Optum_Tech_Labour',
      labelKey: 'Optum_Tech_Labour',
      label: 'Optum Tech Labor',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
      // validations: [{ 'required': true }]
    },
    {
      key: 'Advisory_Service',
      labelKey: 'Advisory_Service',
      label: 'Advisory Services',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
    },
    {
      key: 'Bussiness_Labour',
      labelKey: 'Bussiness_Labour',
      label: 'Business Labor',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
    },
    {
      key: 'Hardware_Software',
      labelKey: 'Hardware_Software',
      label: 'Hardware/Software',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
    },
    {
      key: 'Other_Chargebacks',
      labelKey: 'Other_Chargebacks',
      label: 'Other Chargebacks',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
    },
    {
      key: 'Professional_Fees',
      labelKey: 'Professional_Fees',
      label: 'Professional Fees',
      width: '9.75% !important',
      textAlign: 'center !important',
      currency: true,
      isLastColumn :true
    }
  ];

  FILTERS: any = [];
  filterSegment:any;
  DATA_SCHEMA = {
    "Funding_SegmentID": "select",
    "Funding_Segment": "select",
    "Funding_Owner": "select",
    "ucmg_count": "select",
    "total_acap": "autocomplete",
    "ArchitectDelegate": "autocomplete",
    "isEdit": 'isEdit'
  }

  FILTER_OPTIONS: any = {}
  TABLE_CONFIG: any = {
    expandable: true,
    pageSize: 10,
    pageIndex: 0,
    totalItems: 10,
    selection: false,
    edit: false,
    serverSidePagination: false,
    dependentFilters: {
      MasterSegment: ['Funding_SegmentID', 'Funding_Segment'],
    }
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc',
  }

  showLoader: boolean = true;
  searchField: any;
  searchedText: string = '';
  deleteRecords: any;
  selectedOption:any= 'lob';
  dataSourceFull: any;
  dataPersistObj: MatTableDataSource<any>;
  accessDataSet = false;
  lobDataSet = false;
  restrictionInvesterEdit:boolean = false;
  sort:any;
  public showUcmg: boolean = false;
  tempFilterSegment: any;
  yearList:any = [];
  statusList:any = [];
  ucmgYear:any;
  selectedStatusList = [];
  @Input() capitalDemandRecords:any;
  @Output() toggleChanged = new EventEmitter<boolean>();
  showKPI: boolean = false;
  investmentStatusList:any = [];

  constructor(private readonly router: Router,
    public maintenanceService: MaintenanceService,
    public exportService: ExportDataService,
    private sharedService: SharedService,
    private sharedAuthService: SharedAuthService,
    private route: ActivatedRoute,
    private toaster: ToastrService,
    ) { }

  ngOnInit() {
    this.yearList = [{name:new Date().getFullYear()} ,{name: new Date().getFullYear() + 1}];
    this.statusList = [{name:'Active'},{name:'Inactive'}];
    this.selectedStatusList = [...this.statusList];
    this.deleteRecords = [];
    this.handleAppicationload();
    this.fundOwnerRestrictionEdit();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.fundOwnerRestrictionEdit();
  }

    // Method to restore state from query parameters when coming back from UCMG list view
  private restoreStateFromQueryParams(params: any): void {
    if (params['fiscalYear']) {
      const yearToFind = params['fiscalYear'];
      const yearIndex = this.yearList.findIndex(year => year.name === parseInt(yearToFind, 10));
      this.ucmgYear = this.yearList[yearIndex];
      this.filterDataBasedonYearandStatus();
      this.capTableComponent?.clearallFilter();
    }
    
    // Handle investment status - store for passing to child components
    if (params['selectedStatus']) {
      const statusArray = JSON.parse(params['selectedStatus']);
      // Clear selectedStatusList first
      this.selectedStatusList = [];
      
      // Only add items from statusList that exist in statusArray
      statusArray.forEach(statusItem => {
        const matchingIndex = this.statusList.findIndex(listItem => listItem.name === statusItem.name);
        if (matchingIndex !== -1) {
          // Only push the matching item from statusList if it exists in statusArray
          this.selectedStatusList.push(this.statusList[matchingIndex]);
        }
      });
      
      this.setSelectedValues({data: this.selectedStatusList});
    }

    if(params['searchedText']){
      this.searchField  = params['searchedText'];
      this.searchDataSet();
      }

    }

  refreshAddData(event){
    if(event) {
       this.addUcmgPopup.hide();
      this.getCapitalDemandInvestmentDetails();
    }
  } 



  showpopup() {
       // Open user guide in a new tab securely
       window.open(environment.docUrl+'user-guide/Capital-Demand/#funding-segment-fields-dictionary', '_blank', 'noopener');
  }
  dataRefresh(event){
    if(event){
      this.getCapitalDemandInvestmentDetails();
    }
  }
  handleAppicationload = async () => {
    this.showLoader = true;
    let isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    if(isAdminRole) {
      if (this.sharedAuthService.getFundingAccessDetails('')) {
        this.TABLE_CONFIG['edit'] = true;
      }
      this.accessDataSet = true;
      this.showLoader = this.lobDataSet == true ? false : true;
    } else {
      const msId = this.sharedAuthService.getMsid();
      const secureGroups = JSON.parse(sessionStorage.getItem('secureGroups'));
      msId && this.sharedAuthService.getAccessData(msId, { 'secureGroups': secureGroups }).subscribe(accessData => {
        this.sharedAuthService.setAccessDetailsInSession(accessData);
        if (this.sharedAuthService.getFundingAccessDetails('')) {
          this.TABLE_CONFIG['edit'] = true;
        }
        this.accessDataSet = true;
        this.showLoader = this.lobDataSet == true ? false : true;
      }, (error) => {
        console.error(error);
        this.accessDataSet = true;
        this.showLoader = this.lobDataSet == true ? false : true;
        this.TABLE_CONFIG.edit = false
      });
    }
    this.getCapitalDemandInvestmentDetails();
  }

  searchClear(){
    this.searchField = "";
    this.searchedText = '';
  }
  addUcmg(){
    this.addUcmgPopup.show();
    this.showUcmg = true;
    this.tempFilterSegment = this.tempFilterSegment.map(item=>({...item})
        );
    const element =<any>document.querySelector('.nav-color');
   if(element){element.style.zIndex=1;}
  }



  closeAddModal(type){
    this.addUcmgPopup.closeModal.subscribe((isClosed:boolean)=>{
      if( isClosed && type == 'addUcmg') {
        this.showUcmg = false;
        
      }
     })

  }
 
  getCapitalDemandInvestmentDetails() {
    const filter = this.getFilters();
    let capitalDemandInvestList = [];
    this.maintenanceService.getCapitalDemandInvestmentList().subscribe((result: any) => {
      if (result.length > 0) {
        capitalDemandInvestList = result;
        capitalDemandInvestList.map((element) => {
          if (element.Funding_Owner) {
            element.Funding_Owner = element.Funding_Owner.split('#');
            const arr = [];
          }
        });
        this.filterSegment = result;
        this.tempFilterSegment = result;
        this.deleteRecords = '';
        this.showLoader = true;
        this.searchField = '';
        this.TABLE_CONFIG['TABLE_CLASS'] = 'lob-maintenance-tble-container';
        this.TABLE_CONFIG['FILTER_OPTIONS'] = JSON.parse(JSON.stringify(this.FILTER_OPTIONS));
        this.dataPersistObj = new MatTableDataSource(capitalDemandInvestList);
        this.olddatasource = result;
        this.kpidatasource = _.cloneDeep(result);
        this.dataSourceDetails = _.cloneDeep(this.dataPersistObj);
        this.TABLE_CONFIG.totalItems = capitalDemandInvestList && capitalDemandInvestList.length ? capitalDemandInvestList.length : 0;
        this.lobDataSet = true;
        this.showLoader = this.accessDataSet == true ? false : true;
        if (filter.filters.length == 0) {
          this.dataSourceFull = capitalDemandInvestList;
        }

        this.route.queryParams.subscribe((params) => {
          if (params['segmentView'] || params['fiscalYear'] || params['investmentStatus']) {
            this.investmentStatusList = params['invstStatus']
              ? params['invstStatus'].split(',').map((status) => status.toLowerCase())
              : [];
            this.ucmgYear = params['fiscalYear'] ? { name: parseInt(params['fiscalYear']) } : { name: new Date().getFullYear() };
            this.restoreStateFromQueryParams(params);
          } else {
            this.onYearChange();
            this.FILTERS = [];
            this.searchField = '';
            this.selectedStatusList = [...this.statusList];
            this.capTableComponent?.clearallFilter();
          }
        });

        if (this.clearFilters === true) {
          this.FILTERS = [];
          this.searchField = '';
          this.selectedStatusList = [...this.statusList];
          this.onYearChange();
          this.capTableComponent?.clearallFilter();
        }
      } else {
        this.olddatasource = [];
        this.lobDataSet = true;
      }
    }, error => {
      this.olddatasource = [];
      this.lobDataSet = false;
      console.error('Error fetching capital demand investment details:', error);
      this.toaster.error('Error fetching capital demand investment details', '', { timeOut: 5000, positionClass: 'toast-top-center' });
    });
  }

  
  frameProperCase(name: string) {
    return name.split(' ')
   .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
   .join(' ');
  }

  getFilters() {
    const params: any = {};
    if (this.FILTERS) {
      params['filters'] = this.prepareFilters();
    }

    return params;
  }

  prepareFilters() {
    const filters = [];
    if (this.FILTERS && this.FILTERS.length) {
      this.FILTERS.forEach(element => {
        if (element.key && element.searchValue.length)
          filters.push({ name: element.key, values: element.searchValue });
      });
    }
    return filters;
  }


  /**
  * 
  * @param event 
  */
  tablePaginationEvent(event) {
    if (event) {
      if (event.sort) {
        this.sort = event.sort;
      }
      this.TABLE_CONFIG['pageSize'] = event.pageSize;
      this.TABLE_CONFIG['pageIndex'] = event.pageIndex;
      this.getCapitalDemandInvestmentDetails();
    }
  }

  searchEvent(event) {
    if (event) {
      if (event.type == 'apply') {
        this.FILTERS.push(event.column);
      } else {
        this.FILTERS = this.FILTERS.filter(((ele) => ele.key != event.column.key));
      }
      this.TABLE_CONFIG['pageSize'] = 10;
      this.TABLE_CONFIG['pageIndex'] = 0;
      this.getCapitalDemandInvestmentDetails();
    }
  }

  exportToCsv() {
    this.exportToExcel=this.exportToExcel+1;
  }
  
  navigateHomePage() {
    this.router.navigate([{ outlets: { primary: 'landing-page' } }]);
  }

  searchDataSet() {
    this.capTableComponent?.clearallFilter();
    if (this.olddatasource) {
      this.filterDataBasedonYearandStatus();
    }
  }

  checkBoxEvent(event) {
    let deleteRec = [];
    if (event.data && event.data.length) {
      deleteRec = event.data.map((ele) => {
        const obj: any = {
          LobID: ele['LobID'],
          SubLobID: ele['SubLobID'],
        }
        return obj;
      })
    }
    this.deleteRecords = deleteRec;
  }
  
  selectionTypeChange(event){
    this.selectedOption=event.value;
  }

  fundOwnerRestrictionEdit() {
    const index = this.expanded_columns.findIndex((ele) => ele.key === 'Actions');
    if (index >= 0){
      this.expanded_columns.splice(index, 1);
    }
    this.restrictionInvesterEdit = this.sharedAuthService.getFundingAccessDetails('');
  }

  onYearChange(ev:any = ''){
    if(ev)
      this.ucmgYear = ev.data;
    else
      this.ucmgYear = this.yearList[0];
    if(this.olddatasource && this.olddatasource.length > 0){
      this.filterDataBasedonYearandStatus();
    }
    this.capTableComponent?.clearallFilter();
  }

  setSelectedValues(ev){
    this.selectedStatusList = ev.data;
    this.filterDataBasedonYearandStatus();
    this.capTableComponent?.clearallFilter();
  }
  searchedUcmgId:any;

  private normalizeLower(value: any): string {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase();
  }

  private includesLower(haystack: any, needleLower: string): boolean {
    if (!needleLower) return true;
    return this.normalizeLower(haystack).includes(needleLower);
  }

  filterDataBasedonYearandStatus(){
    this.searchedUcmgId = false;
    const rawSearch = this.searchField ? String(this.searchField).trim() : '';
    const applySearch = rawSearch.length > 2;
    const filterValue = applySearch ? rawSearch.toLowerCase() : '';
    this.searchedText = '';
    let investmentStatus = this.selectedStatusList.map((val)=>val.name);
    const selectedYear = this.ucmgYear?.name;
    const dataSourceArr:Array<any> = _.cloneDeep(this.olddatasource);
    const dataSourceKpiArr: Array<any> = _.cloneDeep(this.kpidatasource);
    let filterArr:Array<any> = dataSourceArr.filter((val)=>{
      let isSearchItemExist : boolean = false;
      
      if(filterValue=='' || ( //filter search
        this.includesLower(val.Funding_SegmentID, filterValue) ||
        this.includesLower(val.Funding_Segment, filterValue) ||
        this.includesLower(val.UCMG_ID, filterValue) || this.includesLower(val.UCMG_Name, filterValue) ||
        this.checkValueExistInArr(val.Funding_Owner,filterValue))){
        isSearchItemExist = true;
      }

      if (filterValue !== '' && /^\d+$/.test(filterValue) && filterValue.length > 2 && this.includesLower(val.UCMG_ID, filterValue)) {
        this.searchedUcmgId = true;
        this.searchedText = rawSearch;
      }
      if (filterValue !== '' && filterValue.length > 2 && val.UCMG_Name && this.includesLower(val.UCMG_Name, filterValue)) {
        this.searchedText = this.searchField;
      }

      //filter year and investment status
      let isYearAndInvestStatus : boolean = false;
      if(investmentStatus && investmentStatus.length > 0){
        investmentStatus = investmentStatus.toString().toLowerCase().split(',');
      }
      const curRowInvestmentStatus = val.investmentStatus?.toLowerCase();
      const isStatusMatch = investmentStatus.length === 0 || investmentStatus.includes(curRowInvestmentStatus);
      const isYearMatch = selectedYear === null || selectedYear === undefined ? true : (val.fiscalYear == selectedYear);
      if(isYearMatch && isStatusMatch ){
        isYearAndInvestStatus = true;
      } else {
        isYearAndInvestStatus = false;
      }
      return isSearchItemExist && isYearAndInvestStatus;
    });

    let kpiFilteredArr:Array<any> = dataSourceKpiArr.filter((val) =>{
      let isSearchItemExist : boolean = false;
      if(filterValue=='' || ( //filter search
        this.includesLower(val.Funding_SegmentID, filterValue) ||
        this.includesLower(val.Funding_Segment, filterValue) ||
        this.checkValueExistInArr(val.Funding_Owner,filterValue))){
        isSearchItemExist = true;
      }

      //filter year and investment status
      let isYearAndInvestStatus : boolean = false;
      if(investmentStatus && investmentStatus.length > 0){
        investmentStatus = investmentStatus.toString().toLowerCase().split(',');
      }
      const curRowInvestmentStatus = val.investmentStatus?.toLowerCase();
      const isStatusMatch = investmentStatus.length === 0 || investmentStatus.includes(curRowInvestmentStatus);
      const isYearMatch = selectedYear === null || selectedYear === undefined ? true : (val.fiscalYear == selectedYear);
      if(isYearMatch && isStatusMatch ){
        isYearAndInvestStatus = true;
      } else {
        isYearAndInvestStatus = false;
      }
      return isSearchItemExist && isYearAndInvestStatus;

    });

    filterArr = this.concatenateActInActviewFS(filterArr);
    this.dataSourceDetails = new MatTableDataSource(filterArr);
    this.getKPIValues(kpiFilteredArr);
  }

  /**
   * Concatenates the active and inactive view of the Funding Segments array.
   * 
   * @param arr - The array of Funding Segments.
   * @returns The concatenated array of Funding Segments.
   */
  concatenateActInActviewFS(arr) {
    const tempArr = [];
    arr.forEach(item => {
      const index = tempArr.findIndex(ele => ele.Funding_SegmentID === item.Funding_SegmentID && ele.fiscalYear === item.fiscalYear);
      if (index === -1) {
        tempArr.push(item);
      } else {
        tempArr[index].flagged_ucmg_count += item.flagged_ucmg_count;
        tempArr[index].ucmg_count += item.ucmg_count;
        tempArr[index].total_acap += item.total_acap;
        tempArr[index].total_OT += item.total_OT;
        tempArr[index].investmentStatus = tempArr[index].investmentStatus+ ',' +item.investmentStatus;
        tempArr[index].green_flag += item.green_flag;
        tempArr[index].yellow_flag += item.yellow_flag;
        tempArr[index].red_flag += item.red_flag;
      }
    });
    return tempArr;
  }

  checkValueExistInArr(arr,value){
    let isExist:boolean = false;
    if (!value) return true;

    if (Array.isArray(arr)) {
      for (const item of arr) {
        if (this.normalizeLower(item).includes(this.normalizeLower(value))) {
          isExist = true;
          break;
        }
      }
      return isExist;
    }

    if (arr === null || arr === undefined) return false;
    return this.normalizeLower(arr).includes(this.normalizeLower(value));
  }

  onToggleChange(isToggled: boolean) {
    this.toggleChanged.emit(isToggled); // Emit the toggle state to the parent
    localStorage.removeItem('filteredData');
    localStorage.removeItem('capitalDemandLeaderSelectedstatus');
    localStorage.removeItem('capitalDemandLeaderKPIValues');
    localStorage.removeItem('selectedHierarchyItems');
  }

  toggleSelectionChanged(event: any) {
    this.checked = event; // Update the variable when the toggle changes
  }

  totalForecastKPI = {
    value: 0,
  };

  ucmgOTKPI = {
    value: 0,
  };

  totalOTKPI = {
    value: 0,
  };

  clearKPIValues(){
    this.totalForecastKPI = {
      value: 0,
    };
    this.ucmgOTKPI = {
      value: 0,
    }
    this.totalOTKPI = {
      value: 0,
    };
  }

  getKPIValues(dataInc){
    //if data exists
    if(dataInc.length <= 0) { this.showKPI = false; return; }
    //clear previous KPI values so we can update
    this.clearKPIValues();
    this.showKPI = true; //show KPI section
    let data = dataInc;

    //loop ucmgs and calculate totals
    for(let ucmg in data){
      //totals
      this.totalForecastKPI.value += Number(data[ucmg]?.total_acap ?? 0);
      this.ucmgOTKPI.value += Number(data[ucmg]?.UCMG_OT ?? 0);
      this.totalOTKPI.value += Number(data[ucmg]?.total_OT ?? 0);
    }
  }

}